import {isNotStringOrEmptyString} from "@utils/string";

export const ValidateStep2Data = (data) => {
   
   const msgList = [/*{
      name: 'halt',
      message: 'Halt'
   }*/];
   
   if(isNotStringOrEmptyString(data.businessHouseNumber)) {
      msgList.push({
         name: 'businessHouseNumber',
         message: 'Please specify the business house number'
      });
   }
   
   if(isNotStringOrEmptyString(data.businessStreetAddress)) {
      msgList.push({
         name: 'businessStreetAddress',
         message: 'Please specify the business street address'
      });
   }
   
   if(isNotStringOrEmptyString(data.businessPostCode)) {
      msgList.push({
         name: 'businessPostCode',
         message: 'Please specify the business post code'
      });
   }
   
   if(isNotStringOrEmptyString(data.businessYearEstablished)) {
      msgList.push({
         name: 'businessYearEstablished',
         message: 'Please specify the year your business was established'
      });
   }
   
   
   
   return msgList;
   
}